import { Box } from '@mui/material';
import AdComponent from '../AdComponent'

export default function SinglePlayerSideBarLeft() {

    return (

    <Box
        sx={{
          width: 380,
          borderRadius: 7,
          flexShrink: 0,
          backgroundColor: '#36454F',
          opacity: [1, 0.2, 1],
          display: {
            xs: 'none',
            md: 'block',
          },
          top: { md: 96 },
          position: { md: 'sticky' },
        }}
      >
        <AdComponent/>
            </Box>



    
    )


}